import React from 'react'
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import Ticket from "./Ticket";
const CustomerTicket = () => {
  return (
    <>
      <Header />
      <Ticket />
      <Footer />
    </>
  )
}

export default CustomerTicket